import { Modal, ModalProps } from '@/modules/common/components/Modal';
import { TaxBenefitsProviderCompanyLinkStatus } from '@/types/tax-benefits-provider';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';

type CancelPartnershipConfirmationModalProps = Omit<
  ModalProps,
  'title' | 'children' | 'onClose'
> & {
  onClose: (cancel: boolean) => void;
  status: TaxBenefitsProviderCompanyLinkStatus;
};

export function CancelPartnershipConfirmationModal({
  onClose,
  status,
  ...props
}: CancelPartnershipConfirmationModalProps) {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, [props.open]);

  return (
    <Modal
      {...props}
      onClose={() => onClose?.(false)}
      title={`Are you sure you want to cancel the ${status === TaxBenefitsProviderCompanyLinkStatus.Invited ? 'invitation' : 'partnership'}?`}
      subTitle="Cancelling the invitation will revoke access to this benefit. This action can be reversed by sending a new invitation."
      classes={{
        paper: 'max-h-full max-w-2xl',
      }}
      showCloseButton
      actions={
        <div className="flex gap-4">
          <Button
            type="button"
            loading={isLoading}
            onClick={() => {
              setLoading(true);
              onClose(true);
            }}
            variant="contained"
          >
            Confirm cancellation
          </Button>
        </div>
      }
    ></Modal>
  );
}
